<template>
  <v-dialog
    v-model="dialogConfirmRedeemFinalVisible"
    persistent
    max-width="340"
  >
    <v-card style="border-radius: 16px; position: relative">
      <!-- Card header -->
      <div class="w-100 pa-3" style="position: relative; height: 70px">
        <h3 class="text-start pl-13 description-label" style="color: black">
          {{ item.name }}
        </h3>
        <p class="text-start text-caption pl-13" style="margin-top: -3px">
          {{ $t("confirmRedeem") }} <br />
        </p>
        <button
          @click="closeDialog"
          style="
            position: absolute;
            width: 26px;
            height: 26px;
            top: 27px;
            left: 20px;
          "
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
            <path
              style="fill: #232326"
              d="M24 12.001H2.914l5.294-5.295-.707-.707L1 12.501l6.5 6.5.707-.707-5.293-5.293H24v-1z"
              data-name="Left"
            />
          </svg>
        </button>
      </div>

      <!-- Card content-->
      <section class="" style="max-height: 400px; overflow-y: auto">
        <!-- reward info -->
        <div class="px-6 text-caption" style="color: grey">
          <p>{{ $t("reward") }} : {{ item.name }}</p>
          <p style="margin-top: -20px">
            {{ $t("redeemAmount", { quantity: quantity }) }}
          </p>
        </div>
        <!-- For address &  & note -->
        <div v-if="!['lucky draw', 'voucher'].includes(item.type)" class="px-6">
          <v-divider style="border-color: rgb(0 0 0 / 20%)"></v-divider>
          <h4 class="mt-3">{{ $t("selectRedeemRewardLocation") }}</h4>

          <v-radio-group v-model="detail.chooseAddress" column>
            <v-radio
              v-if="visibleShipmentIsSelf()"
              :label="
                site.label_shipment == 'รับที่จุดรับของ'
                  ? $t('deliveryPickup')
                  : site.label_shipment
              "
              value="self"
            ></v-radio>
            <v-radio
              v-if="visibleShipmentIsTransport()"
              :label="$t('selectAddressSendReward')"
              value="transport"
            ></v-radio>
          </v-radio-group>

          <div
            v-if="detail.chooseAddress === 'transport' && !userAddress"
            class="d-flex align-center pa-3 mb-3 font-weight-bold text-caption pl-5"
            :style="{ color: site.color }"
            style="
              border-radius: 8px;
              background-color: rgba(217, 217, 217, 0.3);
              margin-top: -10px;
            "
            @click="openAddressDialog"
          >
            <div style="width: 16px; height: 16px" class="mr-3">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <g data-name="51.Add">
                  <path
                    d="M12 24a12 12 0 1 1 12-12 12.013 12.013 0 0 1-12 12zm0-22a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2z"
                  />
                  <path d="M11 6h2v12h-2z" />
                  <path d="M6 11h12v2H6z" />
                </g>
              </svg>
            </div>
            {{ $t("addressAdd") }}
          </div>
          <!-- Have userAddress -->
          <div
            v-if="detail.chooseAddress === 'transport' && userAddress !== null"
            class="pa-3 mb-3"
            style="
              border-radius: 8px;
              background-color: rgba(217, 217, 217, 0.3);
              margin-top: -10px;
              position: relative;
            "
          >
            <button
              @click="openAddressDialog"
              class="font-weight-bold text-caption"
              style="position: absolute; top: 10px; right: 20px"
              :style="{ color: site.color }"
            >
              {{ $t("edit") }}
            </button>
            <p class="font-weight-bold text-caption">
              {{ userAddress.name_address }}
            </p>
            <p style="font-size: 11px; margin-top: -11px">
              {{ userAddress.name }} {{ userAddress.surname }}
              |
              <span>{{ userAddress.mobile }}</span>
            </p>
            <p style="font-size: 12px; margin-top: -11px">
              {{ userAddress.address }}
            </p>
          </div>

          <div v-if="item.is_use_id_card">
            <v-divider style="border-color: rgb(0 0 0 / 20%)"></v-divider>
            <h4 class="mt-3">{{ $t("textUploadIDPassport") }}</h4>
            <v-file-input
              v-model="detail.file"
              class="pr-2 mt-3"
              :placeholder="$t('textSelectFile')"
              small-chips
              show-size
              dense
              @change="changeImage($event)"
              prepend-icon=""
              prepend-inner-icon="mdi-image"
              accept="image/*"
              clearable
            ></v-file-input>

            <!-- for show example with watermark -->
            <div
              style="
                width: 100%;
                border-radius: 8px;
                aspect-ratio: 1.75 / 1;
                background-color: #eeeeee;
                overflow: hidden;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px solid #0000001a;
              "
            >
              <div
                v-if="!detail.id_card_image_watermark"
                style="
                  position: absolute;
                  width: 200%;
                  height: 200%;
                  top: -50%;
                  left: -50%;
                  transform: rotate(-30deg);
                  display: flex;
                  flex-wrap: wrap;
                  align-content: flex-start;
                  justify-content: center;
                  font-size: 28px;
                  font-weight: bold;
                  color: #00000066;
                  line-height: 1.5;
                "
              >
                <span
                  v-for="(item, index) in Array(160)"
                  :key="index"
                  style="margin: 0 24px 24px 0"
                  >{{ detail.watermark_text || "" }}&nbsp;&nbsp;&nbsp;</span
                >
              </div>
              <img
                style="width: 100%; object-fit: cover"
                :src="
                  detail.id_card_image_watermark
                    ? detail.id_card_image_watermark
                    : detail.id_card_image
                    ? detail.id_card_image
                    : defaultIdCardImage()
                "
              />
            </div>

            <!-- for download with watermark -->
            <div style="width: 1px; height: 1px; overflow: hidden">
              <div
                id="id_card_image"
                style="
                  width: 480px;
                  border-radius: 8px;
                  aspect-ratio: 1.75 / 1;
                  background-color: #eeeeee;
                  overflow: hidden;
                  position: relative;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  border: 1px solid #0000001a;
                "
              >
                <div
                  style="
                    position: absolute;
                    width: 200%;
                    height: 200%;
                    top: -50%;
                    left: -50%;
                    transform: rotate(-30deg);
                    display: flex;
                    flex-wrap: wrap;
                    align-content: flex-start;
                    justify-content: center;
                    font-size: 28px;
                    font-weight: bold;
                    color: #00000066;
                    line-height: 1.5;
                  "
                >
                  <span
                    v-for="(item, index) in Array(160)"
                    :key="index"
                    style="margin: 0 24px 24px 0"
                    >{{ detail.watermark_text || "" }}&nbsp;&nbsp;&nbsp;</span
                  >
                </div>
                <img
                  style="width: 100%; object-fit: cover"
                  :src="
                    detail.id_card_image
                      ? detail.id_card_image
                      : defaultIdCardImage()
                  "
                />
              </div>
            </div>
          </div>

          <p
            v-if="shouldHaveIdCardUpload"
            class="pa-2 text-subtitle-2"
            style="color: red"
          >
            *{{ $t("instructionUploadIDPassport") }}
          </p>

          <v-divider
            style="border-color: rgb(0 0 0 / 20%); margin-top: 20px"
          ></v-divider>
          <h4 class="mt-3">{{ $t("note") }}</h4>
          <v-textarea
            v-model="detail.note"
            :color="site.color"
            :placeholder="$t('enterNote')"
            :rows="3"
            class="rounded-lg mt-3"
            dense
            outlined
            no-resize
            background-color="white"
          />
        </div>
      </section>

      <!-- Card Footer -->
      <div
        class="d-flex flex-column align-center justify-center py-5"
        style="width: 100%; box-shadow: 0 -5px 10px rgba(0, 0, 0, 0.1)"
      >
        <div
          v-if="
            showPointUse &&
            Array.isArray(item.point_used) &&
            item.point_used.length > 0
          "
          class="d-flex align-center justify-center font-weight-bold mb-4"
          style="gap: 4px"
        >
          <PointSymbol
            :type="item.point_used[0].point_type_type"
            :symbol="item.point_used[0].point_type_symbol"
            :color="item.point_used[0].point_type_color"
            :is_display="true"
            :outlined_box="false"
            :size="24"
          />
          {{ ((item.point_used[0].point || 0) * (quantity || 1)) | commaPoint }}
          {{ item.point_used[0].point_type_name }}
        </div>
        <v-btn
          :disabled="isDisabled"
          :color="site.color"
          class="rounded-lg font-weight-bold"
          @click="confirmRedeemRewardFinal()"
          style="width: 75%; color: white; height: 40px"
        >
          {{ btnRedeemText }}
        </v-btn>
      </div>
    </v-card>
    <DialogAddressRedeemFinal
      @selectedAddress="handleSelectedAddress"
      :dislogAddressVisible="dislogAddressVisible"
      @close="dislogAddressVisible = false"
      :site="site"
    />
  </v-dialog>
</template>

<script>
import Axios from "@/config/customer-service";
import * as htmlToImage from "html-to-image";
import DialogAddressRedeemFinal from "./dialogAddressRedeemFinal.vue";
import PointSymbol from "../point/point-symbol.vue";

export default {
  inject: ["isAppLoading"],
  data() {
    return {
      canEdit: true,
      detailDefault: {
        chooseAddress: "self",
        note: "",
        is_use_id_card: false,
        id_card_image: null,
        id_card_image_watermark: null,
        watermark_text: null,
        file: null,
        image_error: null,
      },
      detail: {
        chooseAddress: "self",
        note: "",
        is_use_id_card: false,
        id_card_image: null,
        id_card_image_watermark: null,
        watermark_text: null,
        file: null,
        image_error: null,
      },
      dislogAddressVisible: false,
      userAddress: null,
    };
  },
  emits: ["close", "afterRedeemSucess"],
  props: {
    dialogConfirmRedeemFinalVisible: { default: false },
    site: { default: null },
    item: { default: null },
    quantity: { default: null },
    btnRedeemText: {
      default() {
        return this.$t("confirmDefault");
      },
    },
    showPointUse: { default: true },
    fromGamification: { default: false },
  },
  components: {
    DialogAddressRedeemFinal,
    PointSymbol,
  },
  computed: {
    isDisabled() {
      const isUseIdCard = this.item.is_use_id_card === true;
      return (
        this.checkRewardSelect || // reward not selected
        this.isLoading || // still loading
        (isUseIdCard && !this.detail.id_card_image) ||
        (this.detail.chooseAddress === "transport" && !this.userAddress)
      );
    },
    shouldHaveIdCardUpload() {
      const isUseIdCard = this.item.is_use_id_card === true;
      return isUseIdCard && !this.detail.id_card_image;
    },
  },

  methods: {
    visibleShipmentIsSelf() {
      let visible = false;
      if (
        this.site.is_shipment != "Y" ||
        (this.site.is_shipment == "Y" &&
          (!this.item.delivery_type || this.item.delivery_type.length == 0)) ||
        (this.site.is_shipment == "Y" &&
          this.item.delivery_type.includes("pickup"))
      ) {
        visible = true;
      }
      return visible;
    },
    visibleShipmentIsTransport() {
      let visible = false;
      if (
        this.site.is_shipment == "Y" &&
        (!this.item.delivery_type ||
          this.item.delivery_type.length == 0 ||
          this.item.delivery_type.includes("shipping"))
      ) {
        visible = true;
      }
      return visible;
    },

    // ========== ========== ========== ==========
    handleSelectedAddress(chooseAddress) {
      this.userAddress = chooseAddress;
    },
    closeDialog(all) {
      this.$emit("close", all || false); // ส่งอีเวนต์ 'close' ไปยังพ่อแม่
    },
    defaultIdCardImage() {
      return require("@/assets/images/example-thai-id.jpg");
    },
    changeImage(e) {
      this.detail.image_error = false;
      this.detail.file = e;
      this.detail.id_card_image = e ? URL.createObjectURL(e) : null;
      this.detail.id_card_image_watermark = null;
    },
    byhtmlToImage(element) {
      return new Promise((resolve) => {
        htmlToImage
          .toPng(element)
          .then((dataUrl) => {
            resolve(dataUrl);
          })
          .catch((error) => {
            console.error("Error byhtmlToImage:", error);
            resolve(null);
          });
      });
    },
    uploadImageDefault(file) {
      if (file) {
        let formData = new FormData();
        formData.append("image", file);
        formData.append("module", "IDCard");
        return new Promise((resolve, reject) => {
          Axios.post("uploadImageDefault", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
            .then(({ data }) => {
              if (data.status == "success") {
                resolve(data.image_url);
              }
            })
            .catch((err) => {
              console.log(err);
              reject(null);
            });
        });
      } else {
        return null;
      }
    },
    async convertDetailImageBase64(data) {
      let listImageSrc = [data];
      const listImageSrcBase64 = listImageSrc
        .filter((x) => x.includes(";base64,"))
        .map((x) => {
          const detail = {
            old: x,
            new: null,
          };
          return detail;
        });
      if (listImageSrcBase64.length > 0) {
        for (let item of listImageSrcBase64) {
          const imageFile = await this.convertBase64ToFile(item.old, "image");
          if (imageFile) {
            const imageUrl = await this.uploadImageDefault(imageFile);
            if (imageUrl) {
              data = data.replace(item.old, imageUrl);
            }
          }
        }
      }
      return data;
    },
    convertBase64ToFile(base64, nameImage) {
      return new Promise((resolve) => {
        const fetchBase64 = fetch(base64);
        fetchBase64
          .then((r) => r.blob())
          .then((blobFile) => {
            const image = new File([blobFile], nameImage, {
              type: blobFile.type,
            });
            resolve(image);
          })
          .catch((err) => {
            console.log("convertBase64ToFile", err);
            resolve(null);
          });
      });
    },
    openAddressDialog() {
      this.dislogAddressVisible = true;
    },
    async confirmRedeemRewardFinal() {
      if (
        this.detail.is_use_id_card &&
        !this.detail.id_card_image &&
        !this.detail.id_card_image_watermark
      ) {
        this.detail.image_error = true;
        return;
      }

      // ========== ========== check visible pickup ========== ==========
      if (this.item.type == "item") {
        const check_visible_pickup = this.visibleShipmentIsSelf();
        if (!check_visible_pickup && this.detail.chooseAddress == "self") {
          this.$swal({
            icon: "error",
            title: this.$t("instructionAddAddressSendReward"),
            showConfirmButton: false,
            timer: 1500,
          });
          return;
        }
      }

      if (!this.detail.id_card_image_watermark) {
        const element = document.getElementById("id_card_image");
        if (element) {
          let dataUrl = null;
          dataUrl = await this.byhtmlToImage(element);
          const id_card_image_watermark = await this.convertDetailImageBase64(
            dataUrl
          );
          if (id_card_image_watermark) {
            this.detail.id_card_image_watermark = id_card_image_watermark;
          }
        }
      }

      //handle if require id card
      if (this.item.is_use_id_card && !this.detail.id_card_image_watermark) {
        //console.log("have no id_card_image_watermark", this.detail.id_card_image, this.detail.id_card_image_watermark)
        return;
      }

      if (this.item.type == "lucky draw") {
        this.isAppLoading(true);
        Axios.post(`reward/redeempReward`, {
          reward_id: this.item.id,
          number_of_unit: this.quantity,
        })
          .then((res) => {
            if (res.data.status == "success") {
              if (this.item.type === "lucky draw") {
                this.$swal({
                  icon: "success",
                  title: this.$t("redeemSuccess"),
                  showConfirmButton: false,
                  timer: 3000,
                }).then(() => {
                  this.closeDialog();
                  this.$router.push({ name: "my-history" });
                });
              }
            }
          })
          .catch((err) => {
            this.$swal.fire({
              icon: "error",
              title: JSON.stringify(err.response.data.message),
              showConfirmButton: false,
              timer: 3000,
            });
          })
          .finally(() => {
            this.isAppLoading(false);
          });
      } else if (this.item.type == "voucher") {
        this.isAppLoading(true);
        Axios.post(`reward/redeempReward`, {
          reward_id: this.item.id,
          number_of_unit: this.quantity,
        })
          .then((res) => {
            if (res.data.status == "success") {
              if (this.item.type === "voucher") {
                this.$swal({
                  icon: "success",
                  title: this.$t("redeemSuccess"),
                  text: this.$t("infoCouponReadyMyCoupons"),
                  showCancelButton: false,
                  confirmButtonText: this.$t("btnRedirectMyCoupon"),
                  showCloseButton: true,
                  showLoaderOnConfirm: true,
                }).then((result) => {
                  if (result.value) {
                    this.closeDialog();
                    this.$router.push({ name: "my-coupons" });
                  } else {
                    this.closeDialog(true);
                  }
                });
              }
            }
          })
          .catch((err) => {
            this.$swal.fire({
              icon: "error",
              title: JSON.stringify(err.response.data.message),
              showConfirmButton: false,
              timer: 3000,
            });
          })
          .finally(() => {
            this.isAppLoading(false);
          });
      } else {
        if (!this.fromGamification) {
          this.isAppLoading(true);
          Axios.post(`reward/redeempReward`, {
            reward_id: this.item.id,
            number_of_unit: this.quantity,
          })
            .then(async (res) => {
              if (res.data.status == "success") {
                const employee_reward_id = res.data.data.employee_reward_id;
                await this.comfirmRedeem(employee_reward_id);
              }
            })
            .finally(() => {
              this.isAppLoading(false);
            });
        } else {
          Axios.post(
            `gamification/redeemRewardGamification/${this.item.gamification_transactions_id}`
          ).then(async (res) => {
            const dataResponse = res.data;
            if (dataResponse?.status == "success") {
              const employee_reward_id = dataResponse?.data.id;
              if (employee_reward_id) {
                await this.comfirmRedeem(employee_reward_id);
              }
            }
          });
        }
      }
    },
    comfirmRedeem(employee_reward_id) {
      return new Promise((resolve) => {
        let body = {
          employee_reward_id: employee_reward_id,
          id_card_image: this.detail.id_card_image_watermark,
          employee_note: this.detail.note,
        };
        if (this.detail.chooseAddress != "self") {
          //ส่งของตามที่อยู่ -> ส่ง address_id ไปด้วย
          body = {
            ...body,
            address_id: this.userAddress.id,
          };
        }
        Axios.post(`reward/deliverReward`, body)
          .then((res) => {
            if (res.data.status == "success") {
              this.$swal.fire({
                icon: "success",
                title: this.$t("redeemSuccessWithClaimInstruction"),
                showConfirmButton: false,
                timer: 3000,
              });
              if (!this.fromGamification) {
                this.$router.push({ name: "transport" });
              } else {
                this.$emit("afterRedeemSucess");
              }
            }
          })
          .catch((err) => {
            this.$swal.fire({
              icon: "error",
              title: JSON.stringify(err.response.data.message),
              showConfirmButton: false,
              timer: 3000,
            });
          })
          .finally(() => {
            resolve(true);
          });
      });
    },
  },
  watch: {
    dialogConfirmRedeemFinalVisible: {
      handler() {
        if (!this.dialogConfirmRedeemFinalVisible) {
          this.detail = { ...this.detailDefault };
        } else {
          const customer = this.$store.state?.defaultSystem?.customer || {};
          this.detail.note = customer?.employee_note || null;
          this.detail.is_use_id_card = this.item?.is_use_id_card || false;
          this.detail.id_card_image_watermark = null;
          this.detail.watermark_text = this.item?.watermark_text || null;
        }
      },
      deep: true,
    },
  },
  filters: {
    commaPoint(value) {
      // comma point number to baht
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
};
</script>
<style>
.description-label {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>